import React, { useEffect, useState } from 'react';
import { getUserFirstName } from '../../service/UserService';
import PaymentTrends from '../../component/PaymentTrends/PaymentTrends';
import PaymentStatusTileGroup from '../../component/PaymentStatusTileGroup/PaymentStatusTileGroup'
import ProgramOverviewTileGroup from '../../component/ProgramOverviewTileGroup/ProgramOverviewTileGroup';
import './dashboard.css'
import ExpiringPayments from '../../component/ExpiringPayments/ExpiringPayments';
import PaymentSearch from '../../component/PaymentSearch/PaymentSearch';
import { useIsPageDesktop } from '../../App';
import { useCompanyPermission, useCompany } from '../../component/CompanySelection/CompanyContext';
import Has from '../../component/Permission/Has';
import LoadingSpinner from '../../component/LoadingSpinner/LoadingSpinner';
import { FF_DASH_EXPIRED_PAYMENTS, FF_DASH_PAYMENT_TILES, FF_DASH_PAYMENT_TRENDS, FF_DASH_PROGRAM_OVERVIEW } from '../../config/FeatureFlagTypes';

export default function Dashboard() {
    const isDesktop = useIsPageDesktop();
    const [name, setName] = useState("");
    const { companyNumber } = useCompany();

    useEffect(() => {
        if (!companyNumber || typeof companyNumber === 'undefined') {
            return;
        }
        const dataHandler = (data) => {
            if (data) {
                return setName(data);
            }
        };
        getUserFirstName(companyNumber, dataHandler);
    }, [companyNumber])

    //if permissions are not loaded, show loading spinner
    const companyPermission = useCompanyPermission();
    if (!companyPermission) {
        return (
            <div id="dashboard-loader">
                <LoadingSpinner blue />
            </div>
        );
    }

    return (
        <div data-testid="dashboard-page">
            <div className="container-fluid">

                {/* Header */}                
                <div className="row page-title-area">
                    <div className="col-lg-8 page-title">
                        <h1 data-testid="dashboard-welcome-header">Welcome, {name}</h1>
                    </div>
                </div>

                {/* Program Overview */}
                <Has featureFlag={FF_DASH_PROGRAM_OVERVIEW}>
                    <ProgramOverviewTileGroup />
                </Has>

                {/* Payment Trends */}
                <Has featureFlag={FF_DASH_PAYMENT_TRENDS}>
                    {isDesktop ? <PaymentTrends /> : <React.Fragment />}
                </Has>

                {/* <!-- Payments by Status--> */}
                <Has featureFlag={FF_DASH_PAYMENT_TILES}>
                    <PaymentStatusTileGroup heading="Payments by Status" subHeading="Last 12 Months" paymentType="All" />
                </Has>

                {/* <!-- Find Payments (Payment Search + Expiring Payments)--> */}
                <React.Fragment>
                    <div className="row">
                        <div className="col">
                            <div className="sectionTitle">Find Payments</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <PaymentSearch />
                        </div>
                        {isDesktop ? <div className="col">
                            <Has featureFlag={FF_DASH_EXPIRED_PAYMENTS}>
                                <ExpiringPayments />
                            </Has>
                        </div> : <React.Fragment />}
                    </div>
                </React.Fragment>
            </div>
        </div>
    )
}
